export const divideNumberByPieces = (x: number, delimiter = ' '): string => {
    return x
        .toFixed(x % 1 === 0 ? 0 : 2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`);
};
